module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.2607/images/logo/connect-dot-com-icon-white.svg"